import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat5-icon',
  templateUrl: './communication-chat5.component.html'
})
export class CommunicationChat5Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
